import { featureFlags } from 'client/store/modules/FeatureFlagsModule';

const ValueReportMainPanel = () => import('./ValueReportMainPanel.vue');

export default (enabledFlags) => [
  {
    path: '/value-report',
    name: 'valueReport',
    meta: {
      loadLegacyStyles: false,
      returnPath: '/home',
      title: 'Home',
    },
    components: {
      mainPanel: ValueReportMainPanel,
    },
    beforeEnter: (to, from, next) => {
      const showRoute = !!enabledFlags[featureFlags.valueReport];
      if (showRoute) {
        next();
      } else {
        // If coming from outside JC, route to the home page, else go to previous
        const redirect = from.path === '/' ? { path: '/home' } : from;
        next(redirect);
      }
    },
  },
];
